import { useCallback, useEffect, useMemo, useState } from 'react';
import { BREAKPOINT_ENUM } from 'src/common/enums';


export const useResize = () => {
  const [resizeTrigger, setResizeTrigger] = useState(0);

  const isMobile = useMemo(
    () => window.innerWidth <= BREAKPOINT_ENUM.SMALL,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [resizeTrigger]
  );

  const handleResize = useCallback(() => {
    setResizeTrigger((prev) => prev + 1);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return { resizeTrigger, isMobile };
};
